import React, { forwardRef } from 'react';
// import CompareSectionMobile from './compareSectionMobile/CompareSectionMobile';
import { getColorClass } from '../../../../utils/utils';
import { Typography } from '../../../atoms/typography/Typography';
import InfoPopup from '../../../molecules/shared/infoPopup/InfoPopup';

const CompareSection = forwardRef(
  (
    {
      title,
      subtitle,
      items,
      systems,
      shouldRenderValue = (system, item) => true,
      renderValue,
      first,
    },
    ref
  ) => {
    const props = { title, subtitle, items, systems, renderValue, first };

    const filteredItems = items.filter((item) => {
      return (
        systems.filter((system) => {
          return shouldRenderValue(system, item);
        }).length > 0
      );
    });

    if (filteredItems?.length === 0) return null;

    return (
      <div className="flex flex-col" ref={ref}>
        {/* Mobile Section */}
        {/* <CompareSectionMobile {...props} /> */}
        {/* Desktop Section */}
        <div className="flex flex-row justify-between gap-1 sm:gap-5">
          <div className="hidden lg:flex flex-1 flex-col">
            {/* <Typography
              fontVariant="h7"
              textAlign="left"
              title={title}
              className="h-8 font-bold line-clamp-1 break-all"
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                textAlign="left"
                title={subtitle}
                className="h-8 font-bold line-clamp-1"
              >
                {subtitle}
              </Typography>
            )} */}

            <div className="flex flex-1 flex-col gap-1">
              {filteredItems.map((item, index) => (
                <div
                  key={index}
                  className="flex h-8 flex-row items-center gap-1"
                >
                  <Typography
                    textAlign="left"
                    title={item.title ?? item}
                    className="line-clamp-1"
                  >
                    {/* {item.title ?? item} */}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
          {systems.map((system, i) => (
            <div
              key={i}
              className={`flex flex-1 flex-col p-1 sm:p-5 mb-2 divide-y divide-primary-200 ${
                subtitle ? '!pt-16' : ''
              } rounded-xl shadow-md ${getColorClass(i)}`}
            >
              {filteredItems.map((item, index) => (
                <div
                  key={`${i}_index_${index}`}
                  className="flex flex-row justify-between py-2"
                >
                  <span className="text-xs sm:text-base break-words sm:break-normal flex justify-start gap-2">
                    {item.title}{' '}
                    {item.description && (
                      <InfoPopup
                        className="!min-w-[200px]"
                        description={item.description}
                        displayDirection={i === 0 ? 'right' : 'left'}
                      />
                    )}
                  </span>
                  <span className="flex justify-end ">
                    {renderValue(system, item)}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
);

export default CompareSection;
